import React, { useEffect, useMemo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { Link, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import Navbar from '../../components/Navbar';
import { BackTicket, Notify, WrapperAlerts } from '../../components/FixedAlerts';
import Guides from '../../pages/Guides';
import NotFound from '../../pages/404';

import ProviderFilters from '../../providers/Filters';

import { WebsocketContext } from '../../utils/WebsocketProvider';
import { getNavbarConfigSelector } from '../../redux/selectors/header';
import { allRoutes } from '../modules';
import { getAccessRoutes } from '../helpers';

const PrivateRoutes = ({ component: Component }) => {
  const { initWebsockets, socketsInit, socket: webSocket } = useContext(WebsocketContext);

  const { isAuth } = useSelector((state) => state.user);
  const { menu, accessRoutes, dark_mode, parsing_credits, navbarConfig } = useSelector((state) => getNavbarConfigSelector(state));

  const allAccessRoutes = useMemo(() => getAccessRoutes(), []);

  useEffect(() => {
    if (isAuth && !socketsInit && webSocket?.readyState !== 1) {
      initWebsockets(navbarConfig?.websocket_url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Switch>
        {allAccessRoutes.map((route) => {
          if (route.link === '/guides') {
            return <Route key="guides-route" exact path="/guides" component={Guides} />;
          }
          return (
            <Route
              key="private-route"
              exact
              path={route.link}
              render={() => (
                <>
                  {menu && isAuth && (
                    <Navbar
                      component={Link}
                      accessRoutes={accessRoutes}
                      defaultRoutes={allRoutes}
                      parsingCredits={parsing_credits}
                      darkMode={dark_mode}
                    />
                  )}
                  {menu && (
                    <div className="wrapper" id="page-wrapper">
                      <WrapperAlerts>
                        <Notify />
                        <BackTicket />
                      </WrapperAlerts>

                      <div className="page">
                        {route.filters ? (
                          <ProviderFilters>
                            <Component />
                          </ProviderFilters>
                        ) : <Component />}
                      </div>

                    </div>
                  )}
                </>
              )}
            />
          );
        })}
        <Route path="*" component={NotFound} />
      </Switch>
    </>
  );
};
PrivateRoutes.propTypes = {
  component: PropTypes.func,
};

export default PrivateRoutes;
